export default "__VITE_ASSET__c21d7dab__"